import { MapName } from '../types';

const MAP_NAME = 'active_map_name';

export const mapLocalStorage = {
  getName: () => (
    window.localStorage.getItem(MAP_NAME) as MapName | undefined
  ),
  updateName: (value: MapName) => {
    window.localStorage.setItem(MAP_NAME, value)
  },
  deleteName: () => {
    window.localStorage.removeItem(MAP_NAME)
  }
};
